import { times } from 'lodash'

import { Grid, Skeleton } from '@mui/material'

import { Stack, Group } from '@collaborate-health/uikit'

const ReadOnlyCertificateSkeleton: React.FC = () => (
  <Grid container spacing={2}>
    <Grid item xs={6} height={400}>
      <Skeleton variant='rounded' width='100%' height='100%' />
    </Grid>
    <Grid item xs={6}>
      <Stack gap={2.5}>
        <Group fullWidth>
          <Stack gap={2}>
            {times(11, (index) => (
              <Stack key={index} direction='row' justifyContent='space-between'>
                <Skeleton variant='text' width={100} />
                <Skeleton variant='text' width={150 + (index % 2 === 0 ? 25 : -25)} />
              </Stack>
            ))}
          </Stack>
        </Group>
        <Group fullWidth>
          <Stack direction='row' spacing={1}>
            <Skeleton variant='text' width={80} />
            <Skeleton variant='text' width={80} />
            <Skeleton variant='text' width={80} />
          </Stack>
        </Group>
      </Stack>
    </Grid>
  </Grid>
)

export default ReadOnlyCertificateSkeleton

